import script from "./Permissions.vue?vue&type=script&setup=true&lang=js"
export * from "./Permissions.vue?vue&type=script&setup=true&lang=js"

import "./Permissions.vue?vue&type=style&index=0&id=802c2046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-802c2046"]])

export default __exports__